// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCrSU7NPmv0HpkJhynKnl_Pv_gkumdulxo",
  authDomain: "rixxymc-auth.firebaseapp.com",
  projectId: "rixxymc-auth",
  storageBucket: "rixxymc-auth.firebasestorage.app",
  messagingSenderId: "840541934209",
  appId: "1:840541934209:web:40ae72cfd4a2c23b8f7380",
  measurementId: "G-W03Q2SKYMZ"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider };